import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';

import theme from '../../muiTheme';

const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
}

class InvalidateIncidentDialog extends Component {

  render() {
    return (
      <Dialog
       title="Invalidate Incident?"
       modal={true}
       open={this.props.open}
       contentStyle={styles.errorDialogContent}
       titleStyle={styles.errorDialogTitle}>
       <p>Marking this incident as invalid will remove it from Inspector. You'll unable to interact with it further.</p>
       <p>Do you wish to continue?</p>
       <DialogActions>
        <Button onClick={this.props.onRequestClose} color="primary">
          Cancel
        </Button>
        <Button onClick={this.props.onRequestInvalidate} color="primary">
          Ok
        </Button>
      </DialogActions>
     </Dialog>
    )
  }
}

export default InvalidateIncidentDialog;
